import React, {useEffect, useState} from 'react';
import {Container, Paper, Stack} from "@mui/material";
import BreadPath from "../../Components/BreadPath/BreadPath";
import BackGround from "../../Components/BackGround/BackGround";
import {useParams} from "react-router-dom";
import BackServer from "../../api/BackServer";
import {baseUrl_back} from "../../api/BaseUrl";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import OneProductGlass from "../../Components/OneProductShort/OneProductGlass";
import {MDBContainer} from "mdb-react-ui-kit";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const Favorites = (props) => {
    const params = useParams();

    const [products, setProducts] = useState([])
    const [category, setCategory] = useState([])

    const getProducts = async () => {
        var favor= JSON.parse( localStorage.getItem('favorites'))
        await BackServer.GetFavorites(favor).then(u => {
            if (u) {
                setProducts(u.message.Products.lst)
                setCategory(u.message.Products.category)
            }
        })}


    const callup = (len) => {
      //  console.log("OBNOVLENIE")
        getProducts()
        props.callbackX(len)
    }

    useEffect(() => {
        getProducts()
    }, [])

    const Bread=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/newcatalog"},{key:"Избранное", link:category.Url} ]

    return (
        <Container  maxWidth="xl">
            <BreadPath key={"ddd"}  path={Bread}/>
            {/*<Categories/>*/}
            {/*<a>ПРОДУКТЫ</a>*/}
            {/*<a>{category_id}</a>*/}
            {/*<Filters/>*/}
            <Box sx={{ width: '100%' }}>
                <Stack spacing={1}>
                    <h1>{"Избранное"}</h1>
                    <h3>{category.mini_description}</h3>
                    {/*<div className={"myHeigthBar"}>*/}
                    {/*    Сортировка*/}
                    {/*</div>*/}
                    <MDBContainer fluid >
                        {products.map((elm, key) => (
                            <OneProductGlass key={key}   callbak={callup} elm={elm} label={elm.name} img={baseUrl_back+elm.imageUrl}  urlx={elm.Url} />
                        ))}
                    </MDBContainer>

                </Stack>
                {/*<a>корзина  и предупреждение!!</a>*/}
            </Box>
            <h2>{category.description}</h2>



            <BackGround/>
        </Container>
    );
};

export default Favorites;